
import Vue from 'vue'
import appHelper from "./appHelper"


export default class Util {
    static getModuleName () {
        return document.body.getAttribute('module');
    }

    /**
     * instead of console.log , if there was not should to show debug info on console
     */
    static d(){
        if (!Vue.prototype.$isDebug){
            return ;
        }
        for(var x in arguments){
            console.log(arguments[x]);
        }
    }

    //debug alert
    static dAlert(msg){
        if (!Vue.prototype.$isDebug){
            return ;
        }

        appHelper.alert(msg);
    }


    static reloadPage(){
        var url = location.href;
        if (url.indexOf("@aykAPP_native") == -1){
            var para = url.indexOf('?') == -1 ? "?" : "&";
            url = url + para + "@aykAPP_native"
        }
        location.href = url;
    }
    /**
     * 处理ajax公共返回的错误代码
     */
    static resolveRep(rep){

        let detect = appHelper.checkApp();
        this.d(detect);
        if (rep.type == '1001' ){
            if (detect.app){
                appHelper.pipe("showAppLogin",[0]);
                return false;
            }
        } else if ( rep.type != 'succ'){
            appHelper.alert(rep.msg);
            return false;
        }
        return true;
    }

    /**
     * qs 包在Android低版本会报错
     * @param arrObj
     */
    static buildQuery( arrObj ){
        let ret = [];
        for(var x in arrObj){
            ret.push(x + "=" + encodeURI(arrObj[x]));
        }
        return ret.join('&');
    }
}



// WEBPACK FOOTER //
// ./src/lib/util.js